// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   PREMIUM NAVBAR
=============================== */

.premium-navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background: rgba(5, 7, 12, 0.85);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    border-bottom: 1px solid rgba(139, 92, 246, 0.2);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.premium-navbar.scrolled {
    background: rgba(5, 7, 12, 0.95);
    border-bottom-color: rgba(168, 85, 247, 0.3);
    box-shadow: 0 10px 50px rgba(99, 102, 241, 0.2);
}

/* ===============================
   NAVBAR CONTENT
=============================== */

.navbar-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 0;
}

/* ===============================
   LOGO
=============================== */

.navbar-logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s ease;
}

.logo-image {
    height: 40px;
    width: auto;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.navbar-logo:hover .logo-image {
    transform: scale(1.05);
    opacity: 0.9;
}

/* ===============================
   NAVIGATION MENU
=============================== */

.navbar-menu {
    display: flex;
    align-items: center;
}

.nav-list {
    display: flex;
    align-items: center;
    gap: 8px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.nav-list-item {
    position: relative;
}

.nav-list-link {
    display: block;
    padding: 12px 22px;
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    font-size: 0.9375rem;
    font-weight: 600;
    border-radius: 10px;
    transition: all 0.3s ease;
    position: relative;
}

/* Active indicator - Bottom line */
.nav-list-link::after {
    content: '';
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: 24px;
    height: 3px;
    background: linear-gradient(135deg, #6366f1, #a855f7);
    border-radius: 2px;
    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.nav-list-link.active::after {
    transform: translateX(-50%) scaleX(1);
}

.nav-list-link:hover {
    color: #ffffff;
    background: rgba(99, 102, 241, 0.15);
}

.nav-list-link.active {
    color: #ffffff;
    background: rgba(99, 102, 241, 0.1);
}

/* ===============================
   MOBILE TOGGLE
=============================== */

.navbar-toggle {
    display: none;
    flex-direction: column;
    gap: 6px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    z-index: 1001;
}

.navbar-toggle span {
    width: 26px;
    height: 3px;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.navbar-toggle.active span:nth-child(1) {
    transform: rotate(45deg) translateY(9px);
}

.navbar-toggle.active span:nth-child(2) {
    opacity: 0;
    transform: translateX(-15px);
}

.navbar-toggle.active span:nth-child(3) {
    transform: rotate(-45deg) translateY(-9px);
}

/* ===============================
   RESPONSIVE
=============================== */

@media (max-width: 992px) {
    .navbar-toggle {
        display: flex;
    }

    .navbar-menu {
        position: fixed;
        top: 0;
        right: -100%;
        width: 320px;
        height: 100vh;
        background: rgba(5, 7, 12, 0.98);
        backdrop-filter: blur(25px);
        padding: 110px 45px 45px;
        transition: right 0.5s cubic-bezier(0.16, 1, 0.3, 1);
        border-left: 2px solid rgba(139, 92, 246, 0.3);
        box-shadow: -15px 0 50px rgba(99, 102, 241, 0.3);
    }

    .navbar-menu.active {
        right: 0;
    }

    .nav-list {
        flex-direction: column;
        gap: 4px;
        align-items: stretch;
    }

    .nav-list-link {
        padding: 16px 24px;
        font-size: 1.0625rem;
        color: rgba(255, 255, 255, 0.9);
    }

    .nav-list-link::after {
        left: 24px;
        transform: translateX(0) scaleX(0);
        transform-origin: left;
    }

    .nav-list-link.active::after,
    .nav-list-link:hover::after {
        transform: translateX(0) scaleX(1);
    }

    .nav-list-link:hover,
    .nav-list-link.active {
        background: rgba(99, 102, 241, 0.2);
    }
}

@media (max-width: 480px) {
    .navbar-content {
        padding: 18px 0;
    }

    .logo-image {
        height: 40px;
    }

    .navbar-menu {
        width: 100%;
        padding: 100px 35px 35px;
    }

    .nav-list-link {
        font-size: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DarkNavbar.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,2BAA2B;IAC3B,mCAAmC;IACnC,gDAAgD;IAChD,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,+CAA+C;AACnD;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kDAAkD;AACtD;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,qCAAqC;IACrC,WAAW;IACX,WAAW;IACX,qDAAqD;IACrD,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;iCAEiC;;AAEjC;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,MAAM;QACN,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,gCAAgC;QAChC,2BAA2B;QAC3B,wBAAwB;QACxB,oDAAoD;QACpD,8CAA8C;QAC9C,gDAAgD;IACpD;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,+BAA+B;IACnC;;IAEA;QACI,UAAU;QACV,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* ===============================\n   PREMIUM NAVBAR\n=============================== */\n\n.premium-navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1000;\n    background: rgba(5, 7, 12, 0.85);\n    backdrop-filter: blur(25px);\n    -webkit-backdrop-filter: blur(25px);\n    border-bottom: 1px solid rgba(139, 92, 246, 0.2);\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.premium-navbar.scrolled {\n    background: rgba(5, 7, 12, 0.95);\n    border-bottom-color: rgba(168, 85, 247, 0.3);\n    box-shadow: 0 10px 50px rgba(99, 102, 241, 0.2);\n}\n\n/* ===============================\n   NAVBAR CONTENT\n=============================== */\n\n.navbar-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 22px 0;\n}\n\n/* ===============================\n   LOGO\n=============================== */\n\n.navbar-logo {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    transition: all 0.3s ease;\n}\n\n.logo-image {\n    height: 40px;\n    width: auto;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.navbar-logo:hover .logo-image {\n    transform: scale(1.05);\n    opacity: 0.9;\n}\n\n/* ===============================\n   NAVIGATION MENU\n=============================== */\n\n.navbar-menu {\n    display: flex;\n    align-items: center;\n}\n\n.nav-list {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.nav-list-item {\n    position: relative;\n}\n\n.nav-list-link {\n    display: block;\n    padding: 12px 22px;\n    color: rgba(255, 255, 255, 0.85);\n    text-decoration: none;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    border-radius: 10px;\n    transition: all 0.3s ease;\n    position: relative;\n}\n\n/* Active indicator - Bottom line */\n.nav-list-link::after {\n    content: '';\n    position: absolute;\n    bottom: 8px;\n    left: 50%;\n    transform: translateX(-50%) scaleX(0);\n    width: 24px;\n    height: 3px;\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    border-radius: 2px;\n    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.nav-list-link.active::after {\n    transform: translateX(-50%) scaleX(1);\n}\n\n.nav-list-link:hover {\n    color: #ffffff;\n    background: rgba(99, 102, 241, 0.15);\n}\n\n.nav-list-link.active {\n    color: #ffffff;\n    background: rgba(99, 102, 241, 0.1);\n}\n\n/* ===============================\n   MOBILE TOGGLE\n=============================== */\n\n.navbar-toggle {\n    display: none;\n    flex-direction: column;\n    gap: 6px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 10px;\n    z-index: 1001;\n}\n\n.navbar-toggle span {\n    width: 26px;\n    height: 3px;\n    background: #ffffff;\n    border-radius: 3px;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.navbar-toggle.active span:nth-child(1) {\n    transform: rotate(45deg) translateY(9px);\n}\n\n.navbar-toggle.active span:nth-child(2) {\n    opacity: 0;\n    transform: translateX(-15px);\n}\n\n.navbar-toggle.active span:nth-child(3) {\n    transform: rotate(-45deg) translateY(-9px);\n}\n\n/* ===============================\n   RESPONSIVE\n=============================== */\n\n@media (max-width: 992px) {\n    .navbar-toggle {\n        display: flex;\n    }\n\n    .navbar-menu {\n        position: fixed;\n        top: 0;\n        right: -100%;\n        width: 320px;\n        height: 100vh;\n        background: rgba(5, 7, 12, 0.98);\n        backdrop-filter: blur(25px);\n        padding: 110px 45px 45px;\n        transition: right 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n        border-left: 2px solid rgba(139, 92, 246, 0.3);\n        box-shadow: -15px 0 50px rgba(99, 102, 241, 0.3);\n    }\n\n    .navbar-menu.active {\n        right: 0;\n    }\n\n    .nav-list {\n        flex-direction: column;\n        gap: 4px;\n        align-items: stretch;\n    }\n\n    .nav-list-link {\n        padding: 16px 24px;\n        font-size: 1.0625rem;\n        color: rgba(255, 255, 255, 0.9);\n    }\n\n    .nav-list-link::after {\n        left: 24px;\n        transform: translateX(0) scaleX(0);\n        transform-origin: left;\n    }\n\n    .nav-list-link.active::after,\n    .nav-list-link:hover::after {\n        transform: translateX(0) scaleX(1);\n    }\n\n    .nav-list-link:hover,\n    .nav-list-link.active {\n        background: rgba(99, 102, 241, 0.2);\n    }\n}\n\n@media (max-width: 480px) {\n    .navbar-content {\n        padding: 18px 0;\n    }\n\n    .logo-image {\n        height: 40px;\n    }\n\n    .navbar-menu {\n        width: 100%;\n        padding: 100px 35px 35px;\n    }\n\n    .nav-list-link {\n        font-size: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
